import styled, { keyframes } from 'styled-components';

const animation = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const Spinner = styled.div`
    position: relative;
    border-bottom: 0.1em solid;
    border-left: 0.1em solid transparent;
    border-radius: 50%;
    border-right: 0.1em solid transparent;
    border-top: 0.1em solid transparent;
    height: 1em;
    text-indent: -9999em;
    -ms-transform: translateZ(0);
    -webkit-animation: ${animation} 1.1s infinite linear;
    transform: translateZ(0);
    width: 1em;
    overflow: hidden;
    font-size: 1rem;

    &:before {
      content: "";
      position: absolute;
      transform: translateX(-0.5em);
      top: -0.1em;
      border-radius: 50%;
      height: 1em;
      width: 1em;
      border: 0.1em solid ${({ theme }) => theme.colors.text_dark};
      opacity: 0.25;
    }
`;

export default Spinner;